import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import LoadingBar from '../../Modules/LoadingBar';
import AlertError from '../../common/AlertError';
import Receipt from '../../common/Receipt';

import './CreditorMailing.less';


// eslint-disable-next-line react/prefer-stateless-function
class CreditorMailing extends Component {
  handleFocus = e => e.target.select();
  timePassed = timestamp => moment(new Date(timestamp * 1000), 'm/d/yyyy h:MM tt').fromNow();

  render() {
    if (!this.props.dataReady) return <LoadingBar />;
    const alertError = this.props.error ? <AlertError errors={this.props.error} /> : null;

    const { meta = { csv: { title: 'Buy Raw Data' }, pdf: { title: 'Buy 3 Column Format' } }, text = null } = this.props.creditor_mailing;
    const is_not_creditor_mailing_variant = this.props.type != 'creditor_mailing_variant';
    return (
      <div id="ir-search-creditor-mailing-results">
        {alertError}
        <div className="download" style={{ padding: '10px 0', borderBottom: '1px solid gray', marginBottom: '10px' }}>
          <a href="#" className="green form-submit" id="link_download_pdf" onClick={() => this.props.purchaseData('col1')}>{meta.pdf.title}</a>
          <span>(PACER charges apply)</span>
          {meta.pdf.timestamp &&
            <div className="download-link">
              <a href={meta.pdf.link} className="" id="link_download_pdf">
                <img src="/sites/all/themes/inforuptcy/icons/pdficon_large.png" />
              </a>
              <div className="ir-search-refresh-date">
                Last updated: { moment(new Date(meta.pdf.timestamp * 1000)).format('MM/DD/YYYY hh:mm a') } (<span>{this.timePassed(meta.pdf.timestamp)}</span>)
              </div>
            </div>
          }
        </div>
        {is_not_creditor_mailing_variant && 
        <div className="download">
          <a href="#" className="green form-submit" id="link_download_csv" onClick={() => this.props.purchaseData('rawfrmt')}>{meta.csv.title}</a>
          <span>(PACER charges apply)</span>
          {meta.csv.timestamp &&
            <div className="download-link">
              <a href={`/ir-search/query?query=creditor_mailing&case_uuid=${meta.case_uuid}`} className="" id="link_download_csv">
                <img src="/sites/all/themes/inforuptcy/icons/CSV.png" />
              </a>
              <div className="ir-search-refresh-date">
                Last updated: {moment(new Date(meta.csv.timestamp * 1000)).format('MM/DD/YYYY hh:mm a') } (<span>{this.timePassed(meta.csv.timestamp)}</span>)
              </div>
            </div>
          }
        </div>
       }
        <p>
          {text &&
          <React.Fragment>Below is the raw data provided by PACER.</React.Fragment>
        }
          You can download/purchase a CSV or PDF formatted version above.
        </p>
        {text &&
        <textarea style={{ width: '100%', height: '300px' }} onFocus={e => this.handleFocus(e)} value={text} readOnly />
      }
        { this.props.receipt && <Receipt pacerReceipt={this.props.receipt} /> }
      </div>
    );
  }
}

CreditorMailing.defaultProps = {
  error: null,
  receipt: null,
};

CreditorMailing.propTypes = {
  dataReady: PropTypes.bool.isRequired,
  creditor_mailing: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  error: PropTypes.any,
  purchaseData: PropTypes.func.isRequired,
};

export default CreditorMailing;



// WEBPACK FOOTER //
// ./src/components/case/creditor_mailing/CreditorMailing.js